module.exports = __webpack_public_path__ + "static/thirty-2-19022a6737bc75e9078047f23c1fe047.png";